// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ModalBody_modalBody__3rkHf","hasVerticalScrollbar":"ModalBody_hasVerticalScrollbar__2PMpc"};